import type { CompanyRole, GlobalRole, PermissionKey, PermissionSet } from "../types/imobi";

export const permissionKeys: PermissionKey[] = [
  "canCreateAssets",
  "canEditAssets",
  "canDeleteAssets",
  "canDeactivateAssets",
  "canViewAssets",
  "canViewValues",
  "canGenerateReports",
  "canExportPdf",
  "canManageCompanyUsers",
  "canManageCompanySettings",
  "canAuditAssets",
  "canApproveAudit",
  "canViewAuditLogs",
  "canEditDepreciationRules",
  "canStartInventoryCheck",
  "canParticipateInventoryCheck",
  "canCloseInventoryCheck",
  "canPrintAssetLabels",
  "canEditLabelTemplates",
  "canViewExternalServices",
  "canCreateExternalServices",
  "canEditExternalServices",
  "canCloseExternalServices",
  "canAssignAssetsToExternalService",
  "canConfirmExternalServiceAssets",
  "canApproveExternalServiceAssets",
  "canReturnExternalServiceAssets",
  "canGenerateExternalServiceReports",
  "canManageAssetGroups",
  "canManageChecklistTemplates",
  "canPerformInspections"
];

export const emptyPermissions = (): PermissionSet =>
  permissionKeys.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {} as PermissionSet);

export const masterPermissions = (): PermissionSet =>
  permissionKeys.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {} as PermissionSet);

export const defaultPermissionsByCompanyRole: Record<CompanyRole, PermissionSet> = {
  GERENTE: {
    ...masterPermissions(),
    canDeleteAssets: false,
    canApproveAudit: false,
    canEditDepreciationRules: false
  },
  LANCADOR: {
    ...emptyPermissions(),
    canCreateAssets: true,
    canEditAssets: true,
    canViewAssets: true,
    canViewValues: false,
    canGenerateReports: false,
    canExportPdf: false,
    canParticipateInventoryCheck: true,
    canPrintAssetLabels: true,
    canViewExternalServices: true,
    canConfirmExternalServiceAssets: true,
    canReturnExternalServiceAssets: true,
    canPerformInspections: true
  },
  CONSULTA: {
    ...emptyPermissions(),
    canViewAssets: true,
    canGenerateReports: true,
    canViewExternalServices: true
  },
  AUDITOR: {
    ...emptyPermissions(),
    canViewAssets: true,
    canViewValues: true,
    canAuditAssets: true,
    canViewAuditLogs: true,
    canParticipateInventoryCheck: true
  }
};

export function hasGlobalAccess(role: GlobalRole, permission?: PermissionKey): boolean {
  if (role === "MASTER") {
    return true;
  }

  if (role === "ADMIN") {
    return permission !== "canEditDepreciationRules" && permission !== "canEditLabelTemplates";
  }

  return false;
}

export function canAccess(permissions: PermissionSet | undefined, key: PermissionKey, role?: GlobalRole): boolean {
  if (role && hasGlobalAccess(role, key)) {
    return true;
  }

  return Boolean(permissions?.[key]);
}
